import { withCompInfo } from '@wix/editor-elements-integrations'
import type { FastGalleryDefinition } from './FastGallery'

export const props = withCompInfo<any, FastGalleryDefinition>()(
	// @ts-ignore
	['hasResponsiveLayout', 'responsiveContainerProps', 'containerRootClassName', 'compMeshProps'],
	// @ts-ignore
	({ hasResponsiveLayout, responsiveContainerProps, containerRootClassName, compMeshProps }) => {
		return hasResponsiveLayout
			? {
				containerProps: responsiveContainerProps,
				containerRootClassName,
			}
			: { meshProps: compMeshProps }
	}
)
